export const overSpeedRecordListUrl = '/overSpeedRule/ruleAlarmRecords'
export const overSpeedRecordExportUrl = '/overSpeedRule/exportRecords'
